import React from 'react';
import { AttackVisual } from './engine';

export function AttackEffects({ effects, paused }: { effects: AttackVisual[]; paused: boolean }) {
    return <svg className={`arena-overlay attack-overlay${paused ? ' attack-paused' : ''}`} viewBox="0 0 100 42.857" preserveAspectRatio="none" aria-hidden="true">
        {effects.map(f => {
            const melee = f.type === 'Melee';
            const angle = Math.atan2(f.y - f.fromY, f.x - f.fromX) * 180 / Math.PI;
            return <g key={f.id} className={`attack-effect attack-${f.type.toLowerCase()}`}>
                {!melee && <g className="attack-projectile" style={{ '--from-x': `${f.fromX}px`, '--from-y': `${f.fromY}px`, '--to-x': `${f.x}px`, '--to-y': `${f.y}px` } as React.CSSProperties}>
                    <g transform={`rotate(${angle})`}>
                        {f.type === 'Range' ? <path d="M-2.5 0H.7M-.1 -.5L.8 0 -.1 .5M-2.4 -.35L-1.8 0 -2.4 .35" fill="none" stroke="currentColor" strokeWidth=".18"/> : <><path d="M-3 0H0" stroke="currentColor" strokeWidth=".3" opacity=".45"/><circle r=".45" fill="currentColor"/><circle r=".2" fill="#fff6ff"/></>}
                    </g>
                </g>}
                <g transform={`translate(${f.x} ${f.y})`}>
                    <g className={`attack-impact${melee ? ' melee-impact' : ''}`}>
                        {melee ? <><path d="M-1.8 1.5Q-.5 -1.8 2 -1.5M-1.2 1.6L1.2 -1.2" fill="none" stroke="currentColor" strokeWidth=".32" strokeLinecap="round"/><path d="M-1.3 -.6L1.3 .6M0 -1.1V1.1" stroke="#fff5cc" strokeWidth=".15"/></> : <><circle r="1.1" fill="none" stroke="currentColor" strokeWidth=".18"/><path d="M-1.5 0H1.5M0 -1.5V1.5" stroke="currentColor" strokeWidth=".15"/></>}
                    </g>
                </g>
            </g>;
        })}
    </svg>;
}
